import {getAllEquipments} from '../../services/EquipmentServices'

export function getDefaultCapacityForEquipType(equipTypeName) {
  const name = String(equipTypeName || '').trim().toUpperCase();
  if (name === 'TRANSIT MIXER') {
    return 12;
  }
  if (name === 'TIPPER') {
    return 50;
  }
  return 1;
}

export function resolveEquipTypeName(equipTypeId, groupList) {
  const selected = (groupList || []).find((item) => String(item.id) === String(equipTypeId));
  return selected?.entity_name || '';
}

function isSystemGroup(item) {
  return item?.system_field === 1 || item?.system_field === true;
}

export function getEquipmentTypeOptions(accountsGroupingList) {
  const list = accountsGroupingList || [];
  const equipmentParent =
    list.find((obj) => obj.entity_name === 'EQUIPMENT' && isSystemGroup(obj)) ||
    list.find((obj) => obj.entity_name === 'EQUIPMENT');

  if (!equipmentParent) {
    return [];
  }

  return list
    .filter((obj) => String(obj.parent_id) === String(equipmentParent.id))
    .sort((a, b) => String(a.entity_name || '').localeCompare(String(b.entity_name || '')));
}

export function getSubmitCapacity(equipTypeId, groupList) {
  return getDefaultCapacityForEquipType(resolveEquipTypeName(equipTypeId, groupList));
}

export function checkForDuplicateEquipments(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
        getAllEquipments(cookies)
      .then((data) => {

        let isUserExists = false;
        for(var i=0; i<data.salesrep_data.length; i++)    //Same Sales Representative Name mentioned it denoted already exist.
        {
          if((data.salesrep_data[i].entity_name) === value.trim().toUpperCase()
            && parseInt(existingId) !== data.salesrep_data[i].id){   
            
            console.log(`User exists with the name - ${value}`) 
            isUserExists = true;
            break;
          }
        }
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }